import { Component, Injector, OnInit, signal, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
//import { JkbillService } from '../../services/jkbill.service';
import { JkComboboxComponent } from '../jkcombobox/jkcombobox.component';
import { CrudbarNavComponent } from '../crudbar-nav/crudbar-nav.component';
import { uiModeList, UiModeType } from '../../services/jkInterface';
import { MaterialModule } from '../../material.module';
import { entityState } from '../../services/jkEntityTypes';
import { PageService } from '../../services/page.service';
import { FormsModule } from '@angular/forms';

/**
 * CRUD操作工具列組件
 *
 * 提供基本的CRUD操作按鈕和額外的業務操作按鈕（確認、作廢、列印、附件等）。
 * 此組件繼承自CrudbarNavComponent，擴展了基本功能並添加了更多業務相關的按鈕。
 * 組件會根據當前的實體狀態自動調整按鈕的啟用/停用狀態。
 */
@Component({
  selector: 'app-crudbar',
  templateUrl: './crudbar.component.html',
  //styleUrls: ['./crudbar.component.scss'],
  styleUrls: [],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MaterialModule,
    MatIcon
],
})

export class CrudbarComponent extends CrudbarNavComponent implements OnInit {
  //doHelp($event: any) {
  /*doHelp(): void {
    //http://localhost:4200/helpviewer?SH001=002&SH013=PACKAGE
    const url = this.login.host + '/helpviewer?SH001=' + this.programId;// + '&SH013=' + this.login.userid;
    const w = window.open(
      url,
      '_blank',
      'menubar=no,status=no,scrollbars=no,top=0,left=0,toolbar=no',
    );

  }*/
  override comType: string = 'crudbar';

  /**
   * 執行確認操作
   * @param $event 滑鼠事件對象
   */
  doConfirm($event: any) {
    alert('未完工')
  }

  /**
   * 執行取消確認操作
   * @param $event 滑鼠事件對象
   */
  doCancelConfirm($event: any) {
    alert('未完工')
  }

  /**
   * 執行作廢操作
   * @param $event 滑鼠事件對象
   */
  doVoid($event: any) {
    alert('未完工')
  }

  /**
   * 執行列印操作
   * @param $event 滑鼠事件對象
   */
  doPrint($event: any) {
    alert('未完工')
  }

  /**
   * 執行附件操作
   * @param $event 滑鼠事件對象
   */
  doAttach($event: any) {
    alert('未完工')
  }
  uiModeList = uiModeList;

  /** 確認按鈕是否可見 */
  confirmVisible: boolean = true;

  /** 確認按鈕是否禁用 */
  confirmDisabled: boolean = true;

  /** 取消確認按鈕是否可見 */
  cancelConfirmVisible: boolean = true;

  /** 取消確認按鈕是否禁用 */
  cancelConfirmDisabled: boolean = true;

  /** 作廢按鈕是否可見 */
  voidVisible: boolean = true;

  /** 作廢按鈕是否禁用 */
  voidDisabled: boolean = true;

  /** 列印按鈕是否可見 */
  printVisible: boolean = true;

  /** 列印按鈕是否禁用 */
  printDisabled: boolean = false;

  /** 附件按鈕是否可見 */
  attachVisible: boolean = true;

  /** 附件按鈕是否禁用 */
  attachDisabled: boolean = false;
  cbQuery?: () => void;

  /**
   * 設定單據狀態
   * 設定單據狀態並更新按鈕狀態
   * @param value 實體狀態
   */
  private _billState: entityState = entityState.dsBrowse;

  set billState(value: entityState) {
    this._billState = value;
    this.setMode(value);
  }

  /**
   * 獲取單據狀態
   * @returns 實體狀態
   */
  get billState(): entityState {
    return this._billState;
  }
  /** 首頁按鈕是否可見 */
  public readonly homeVisible = input(true);

  /** 返回按鈕是否可見 */
  public readonly backVisible = input(true);

  /** 查詢按鈕是否可見 */
  public readonly queryVisible = input(true);

  /** 首頁按鈕是否禁用 */
  homeDisabled = signal(false);

  /** 返回按鈕是否禁用 */
  backDisabled = signal(false);
  private router: Router;
  private locate: Location;

  constructor() {
    const injector = inject(Injector);
    const page = inject(PageService);

    super();
    this.router = page.router; // injector.get(Router);
    this.locate = injector.get(Location);
    //this._mode = 'browse';
  }

  public get test(): boolean {
    return this.deleteDisabled;
  }
  public set test(t: boolean) {
    this.deleteDisabled = t;
  }
  override ngAfterViewInit() {
    super.ngAfterViewInit();
  }

  override ngOnInit() {
    // Add your implementation here
    super.ngOnInit();
  }
  /**
   * 根據實體狀態設定按鈕的啟用/停用狀態
   * @param state 實體狀態
   */
  /**
   * 重寫設定模式方法，使用signals解決 ExpressionChangedAfterItHasBeenCheckedError
   * @param state 實體狀態
   */
  override setMode(state: entityState) {
    state = entityState.dsBrowse; // TODO: 20260228 暫時不使用
    // 調用父類的 setMode，navigateVisible 的變更會延遲到下一個週期
    super.setMode(state);

    // 使用signals解決變更檢測時序問題
    if (state === entityState.dsBrowse) {
      this.homeDisabled.set(false);
      this.backDisabled.set(false);

      // 父類屬性繼續使用傳統方式
      this.queryDisabled = false;
      this.printDisabled = false;
      this.attachDisabled = false;
    } else {
      this.homeDisabled.set(true);
      this.backDisabled.set(true);

      // 父類屬性繼續使用傳統方式
      this.queryDisabled = true;
      this.printDisabled = true;
      this.attachDisabled = true;
    }
  }

  /**
   * 執行查詢操作
   * @param $event 事件對象
   */
  doQuery($event: any) {
    if (this.cbQuery) this.cbQuery();
  }
  override async doInsert($event: any) {
    await super.doInsert($event);
    this.billState = entityState.dsInsert; // this.billSrv.master.state;
  }
  override doEdit($event: any) {
    super.doEdit($event);
    //if (this.cbEdit) this.cbEdit();
    //this.state = this.billSrv.masterState;
    this.billState = entityState.dsEdit;//this.billSrv.masterState;
    //this.billSrv.doEdit();
  }
  override async doPost($event: any) {
    await super.doPost($event);
    // cbPost 回傳 true 才切換到 dsBrowse；false 表示儲存失敗，維持編輯狀態
    if (this._billState !== entityState.dsBrowse) {
      this.billState = entityState.dsBrowse;
    }
  }
  override doCancel($event: any) {
    super.doCancel($event);
    //if (this.cbCancel) this.cbCancel();
    this.billState = entityState.dsBrowse; //  this.billSrv.masterState;
    //this.billSrv.doCancel();
  }
  /*doDelete($event: any) {
    //if (confirm('是否刪除此筆資料?')) {
      if (this.cbDelete) this.cbDelete();
      else {
        alert('cbDelete is not defined');
      }
      //this._billSrv?.doUIDelete();
    //}

  }*/
  /*
  user1($event: any) {
    if (this.cbUser1) this.cbUser1();
  }
  user2($event: any) {
    if (this.cbUser2) this.cbUser2();
  }
  user3($event: any) {
    if (this.cbUser3) this.cbUser3();
  }
  user4($event: any) {
    if (this.cbUser4) this.cbUser4();
  }*/
  /**
   * 導航到指定URL
   * @param url 目標URL路徑
   */
  setRoot(url: string) {
    /*return this.navCtrl.navigateRoot(url, {
      animated: true,
      animationDirection: 'forward',
    });
    */
    this.router.navigate([url]);
    // this.router.navigate([page], { queryParams });

  }
  // doBack(){
  //   this.locate.back();
  // }

}
